import zaheryacoub from "../images/reviews/zaheryacoub.webp"; 
import hasanyacoub from "../images/reviews/hasanyacoub.webp"; 
import ajayc4 from "../images/reviews/ajayc4.webp"; 
import rockypb from "../images/reviews/rockypb.webp"; 



const Reviews = [
  {
    id: 1,
    name: "rockypb",
    bio: "Diamond Seller in USA",
    img: rockypb,
    description:
      "His creativity and attention to detail have given us a website that perfectly encapsulates our diamonds & Jewellery website.",
    rating: 5.0,
  },
  {
    id: 2,
    name: "ajayc4",
    bio: "Astrologer",
    img: ajayc4,
    description:
      "Jenil, has done the job quickly and the work done in a very professional manner. The response time and communication part was execllent.",
    rating: 5.0,
  },
  {
    id: 3,
    name: "Zaher Yacoub",
    bio: "Founder @Agile Solutions Consultants",
    img: zaheryacoub,
    description:
      "His understanding to the needs and the quick responses.",
    rating: 5.0,
  },
  {
    id: 4,
    name: "Hasan Yacoub",
    bio: "Diamond Jewellery Seller",
    img: hasanyacoub,
    description:
      "Jenil was great! Will definitely use him in the future!",
    rating: 5.0,
  },
];

export default Reviews;
